const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroScrollIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02537 3.33518C8.57297 2.78757 9.31568 2.47993 10.0901 2.47993H13.9101C14.6845 2.47993 15.4273 2.78757 15.9749 3.33518C16.5225 3.88278 16.8301 4.6255 16.8301 5.39993V10.1699C16.8301 11.4509 16.3212 12.6795 15.4154 13.5853C14.5096 14.4911 13.2811 14.9999 12.0001 14.9999C10.7191 14.9999 9.49059 14.4911 8.58479 13.5853C7.67899 12.6795 7.17012 11.4509 7.17012 10.1699V5.39993C7.17012 4.6255 7.47776 3.88279 8.02537 3.33518ZM10.0901 0.679932C8.8383 0.679932 7.63774 1.17722 6.75257 2.06239C5.8674 2.94756 5.37012 4.14811 5.37012 5.39993V10.1699C5.37012 11.9283 6.06863 13.6147 7.312 14.858C8.55537 16.1014 10.2417 16.7999 12.0001 16.7999C13.7585 16.7999 15.4449 16.1014 16.6882 14.858C17.9316 13.6147 18.6301 11.9283 18.6301 10.1699V5.39993C18.6301 4.14811 18.1328 2.94756 17.2477 2.06239C16.3625 1.17722 15.1619 0.679932 13.9101 0.679932H10.0901ZM11.1001 4.45001V7.31001H12.9001V4.45001H11.1001Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13965 18.8999L11.9996 21.7599L14.8596 18.8999",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroScrollIcon);
export default __webpack_public_path__ + "static/media/hero-scroll-icon.ea61cdf16e420ed591841330f53b4fe0.svg";
export { ForwardRef as ReactComponent };